import { RAGColourValue } from '../../../library/enums';
export function generateLabel(percentage) {
    if (percentage <= RAGColourValue.R)
        return 'Basic';
    if (percentage <= RAGColourValue.A)
        return 'Intermediate';
    return 'Advanced';
}
